import React, { useEffect, useState } from 'react';
import * as Icons from 'react-feather';
import DataTable from 'react-data-table-component';
import { ReactComponent as SortArrow } from '../../shared/img/chevron-up-down.svg';

function VehicleSalesGrid({ data, onSelectEntry, onFieldChange, onDelete }) {
  const [rows, setRows] = useState([]);

  const customStyles = {
    table: {
      style: {
        minWidth: '1200px'
      }
    }
  };

  useEffect(() => {
    setRows(Array.isArray(data) ? data : []);
  }, [data]);

  const columns = [
    {
      name: '',
      width: '60px',
      center: true,
      cell: (row) => (
        <input
          type="checkbox"
          checked={Boolean(row.Selected)}
          onChange={(e) => onSelectEntry?.(row, e.target.checked)}
          className="form-check-input"
        />
      )
    },
    {
      name: <div className="titlename"><span>Vehicle</span></div>,
      selector: (row) => row.Vehicle || row.VehicleLabel || row.VehicleNameValue || row.VehicleName,
      cell: (row) => {
        const label = row.Vehicle || row.VehicleLabel || row.VehicleNameValue || row.VehicleName || '';
        return <span title={label}>{label}</span>;
      },
      sortable: true,
      sortIcon: <span><SortArrow /></span>,
      width: '260px'
    },
    {
      name: <div className="titlename"><span>Vehicle Cost</span></div>,
      selector: (row) => row.VehicleCost,
      cell: (row) => <span title={row.VehicleCost}>{row.VehicleCost}</span>,
      sortable: true,
      sortIcon: <span><SortArrow /></span>
    },
    {
      name: <div className="titlename"><span>Payment Type</span></div>,
      selector: (row) => row.PaymentType,
      cell: (row) => <span title={row.PaymentType}>{row.PaymentType}</span>,
      sortable: true,
      sortIcon: <span><SortArrow /></span>,
      width: '90px'
    },
    {
      name: <div className="titlename"><span>Down Payment</span></div>,
      selector: (row) => row.DownPayment,
      cell: (row) => <span title={row.DownPayment}>{row.DownPayment}</span>,
      sortable: true,
      sortIcon: <span><SortArrow /></span>
    },
    {
      name: <div className="titlename"><span>EMI Tenure</span></div>,
      selector: (row) => row.EMITenure,
      cell: (row) => <span title={row.EMITenure}>{row.EMITenure}</span>,
      sortable: true,
      sortIcon: <span><SortArrow /></span>,
      width: '80px'
    },
    {
      name: <div className="titlename"><span>EMI Amount</span></div>,
      selector: (row) => row.EMIAmount,
      cell: (row) => <span title={row.EMIAmount}>{row.EMIAmount}</span>,
      sortable: true,
      sortIcon: <span><SortArrow /></span>,
      width: '90px'
    },
    {
      name: <div className="titlename"><span>Processing Fees</span></div>,
      selector: (row) => row.ProcessingFees,
      cell: (row) => <span title={row.ProcessingFees}>{row.ProcessingFees}</span>,
      sortable: true,
      sortIcon: <span><SortArrow /></span>
    },
    {
      name: <div className="titlename"><span>Chassis No</span></div>,
      selector: (row) => row.ChassisNo,
      cell: (row) => (
        row.Selected
          ? (
            <input
              type="text"
              className="form-control form-control-sm"
              value={row.ChassisNo ?? ''}
              onChange={(e) => onFieldChange?.(row.id, 'ChassisNo', e.target.value)}
            />
          )
          : <span title={row.ChassisNo}>{row.ChassisNo}</span>
      ),
      sortable: true,
      sortIcon: <span><SortArrow /></span>
    },
    {
      name: <div className="titlename"><span>Engine No</span></div>,
      selector: (row) => row.EngineNo,
      cell: (row) => (
        row.Selected
          ? (
            <input
              type="text"
              className="form-control form-control-sm"
              value={row.EngineNo ?? ''}
              onChange={(e) => onFieldChange?.(row.id, 'EngineNo', e.target.value)}
            />
          )
          : <span title={row.EngineNo}>{row.EngineNo}</span>
      ),
      sortable: true,
      sortIcon: <span><SortArrow /></span>
    },
    {
      name: <div className="titlename">Actions</div>,
      cell: (row) => (
        <div className="edit-delete-action">
          <span
            className="confirm-text p-2"
            style={{ display: 'inline-flex', cursor: 'pointer' }}
            title="Delete"
            onClick={() => onDelete?.(row)}
          >
            <Icons.Trash2 data-feather="trash-2" className="feather-trash-2" />
          </span>
        </div>
      ),
      center: 'true',
      width: '100px'
    }
  ];

  return (
    <div className="card table-list-card">
      <div className="card-body">
        <div className="table-responsive product-list" style={{ overflowX: 'auto' }}>
          <DataTable
            columns={columns}
            data={rows}
            sortIcon={<SortArrow />}
            persistTableHead
            customStyles={customStyles}
          />
        </div>
      </div>
    </div>
  );
}

export default VehicleSalesGrid;
